export enum StorageAreaType {
  Undefined = 0,
  Producer = 1,
  Consumer = 2,
  Vehicle = 3,
  LogSorterIntake = 4,
  SawLineIntake = 5,
  LogSorterBin = 6,
  SortedPile = 7,
  UnsortedPile = 8,
  Truck = 9,
  Train = 10,
  CoilStack = 11,
  Bulk = 12,
  PackageStorage = 13,
  ProductionLine = 14,
  PackageOutput = 15,
  PackageIntake = 16,
}

export function isLogYard(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.SortedPile:
    case StorageAreaType.UnsortedPile:
    case StorageAreaType.LogSorterBin:
    case StorageAreaType.LogSorterIntake:
    case StorageAreaType.SawLineIntake:
      return true;
  }

  return false;
}

export function isLogYardPile(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.SortedPile:
    case StorageAreaType.UnsortedPile:
      return true;
  }

  return false;
}

export function isCoilStorage(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.CoilStack:
      return true;
  }

  return false;
}

export function isBulkStorage(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.Bulk:
      return true;
  }

  return false;
}

export function isPackageStorage(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.PackageStorage:
      return true;
  }

  return false;
}

export function isProductionLine(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.ProductionLine:
      return true;
  }

  return false;
}

export function isPackageOutput(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.PackageOutput:
      return true;
  }

  return false;
}

export function isPackageIntake(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.PackageIntake:
      return true;
  }

  return false;
}

/** Areas that carry configurable package places (output and intake). */
export function isPackagePlaceArea(type: StorageAreaType) {
  switch (type) {
    case StorageAreaType.PackageOutput:
    case StorageAreaType.PackageIntake:
      return true;
  }

  return false;
}
